export type LogMethod = (message?: any, ...optionalParams: any[]) => void;

const isLive = typeof env !== 'undefined' && env === 'live';

export class Logger {
  private readonly name: string;

  constructor(name: string) {
    this.name = name;
  }

  private prefix(level: string, message?: any) {
    if (typeof message === 'string') {
      return `[${this.name}] ${level}: ${message}`;
    }
    return message;
  }

  trace: LogMethod = (message?: any, ...optionalParams) => {
    if (!isLive) {
      console.debug(this.prefix('TRACE', message), ...optionalParams);
    }
  };

  debug: LogMethod = (message?: any, ...optionalParams) => {
    if (!isLive) {
      console.debug(this.prefix('DEBUG', message), ...optionalParams);
    }
  };

  info: LogMethod = (message?: any, ...optionalParams) => {
    if (!isLive) {
      console.info(this.prefix('INFO', message), ...optionalParams);
    }
  };

  warn: LogMethod = (message?: any, ...optionalParams) => {
    if (!isLive) {
      console.warn(this.prefix('WARN', message), ...optionalParams);
    }
  };

  error: LogMethod = (message?: any, ...optionalParams) => {
    if (!isLive) {
      console.error(this.prefix('ERROR', message), ...optionalParams);
    }
  };

  fatal: LogMethod = (message?: any, ...optionalParams) => {
    if (!isLive) {
      console.error(this.prefix('FATAL', message), ...optionalParams);
    }
  };

  removeAllAppenders() {
    // no-op
  }

  addAppender(_appender: unknown) {
    // no-op
  }
}

export function getLogger(name: string): Logger {
  return new Logger(name);
}

export class BrowserConsoleAppender {
  setLayout(_layout: unknown) {
    // no-op
  }
}

export class PatternLayout {
  constructor(_pattern: string) {
    // no-op
  }
}
